import sharedClasses from '@utils/shared-classes';
import { cva } from 'class-variance-authority';

export const blockActionsClasses = cva(
  [
    ...sharedClasses.microInteractions,
    'top-0',
    'left-0',
    'fixed',
    'bg-transparent',
    'group-hover:bg-white',
    'group-hover:shadow-lg',
    'group-hover:sticky',
    'hover:bg-white',
    'hover:shadow-lg',
    'hover:sticky',
    'p-2',
    'group',
    'w-fit',
    'h-fit',
    'pointer-events-none',
    'rounded-full',
    'shadow-none',
    'transform',
    'translate-x-1',
  ],
  {
    variants: {
      alwaysVisible: {
        true: ['bg-white', 'shadow-lg', 'sticky'],
        false: ['group-hover:bg-white', 'group-hover:shadow-lg', 'group-hover:sticky'],
      },
    },
  },
);

export const iconClasses = cva(['block', ...sharedClasses.microInteractions], {
  variants: {
    comments: {
      true: ['pointer-events-auto'],
      false: ['scale-0'],
    },
    isDisabled: {
      true: ['!cursor-default hover:text-gray-600 opacity-50'],
      false: ['hover:text-primary-500', 'cursor-pointer'],
    },
    alwaysVisible: {
      true: ['visible', 'scale-100', 'pointer-events-auto'],
      false: ['group-hover:visible', 'group-hover:scale-100', 'group-hover:pointer-events-auto'],
    },
  },
  defaultVariants: {
    alwaysVisible: false,
    comments: false,
    isDisabled: false,
  },
});
